import React from 'react'
import Input from 'components/input'
import FieldLabel from './FieldLabel'
import FieldErrorView from './FieldErrorView'
import ErrorText from 'components/ErrorText'
import Optional from 'components/Optional'

const Field = ({
  label,
  className,
  error,
  required = true,
  note,
  halfWidth,
  extraActions,
  optionalLabel,
  showErrors,
  ...inputProps
}) =>
  label ? (
    <div className={`${className} ${error ? 'error' : ''}`}>
      <FieldLabel radio={inputProps.radio} htmlFor={inputProps.id || ''} error={error}>
        {label}
        {required || <Optional withMargin>{optionalLabel}</Optional>}
      </FieldLabel>
      <FieldErrorView error={!inputProps.radio && error} halfWidth={halfWidth}>
        <Input error={error} {...inputProps} />
        {error ? <ErrorText radio={inputProps.radio}>{error}</ErrorText> : note}
      </FieldErrorView>
      {extraActions}
    </div>
  ) : (
    <FieldErrorView error={showErrors && !inputProps.radio && error} halfWidth={halfWidth}>
      <Input error={showErrors && error} {...inputProps} />
      {error ? <ErrorText radio={inputProps.radio}>{error}</ErrorText> : note}
    </FieldErrorView>
  )

export default Field
